import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_CopyOrders.scss';
import { BadImplementationException } from '@nu-art/ts-common';
import { DropDown_EHRInstallation, ModuleFE_EHRInstallation } from '../../../../../../_entity/installation/ehr-installation/index.js';
export class Dialog_CopyOrders extends ComponentSync {
    static show = (data) => {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_CopyOrders, { ...data }) });
    };
    deriveStateFromProps(nextProps, state) {
        state.canCopy ??= !!state.originEHRInstallationId;
        return state;
    }
    onSelectEHRInstallation = (ehrInstallation) => {
        this.setState({ originEHRInstallationId: ehrInstallation._id, canCopy: !!ehrInstallation._id });
    };
    onClickCopy = async () => {
        const { originEHRInstallationId } = this.state;
        const { targetEHRInstallationId } = this.props;
        if (!originEHRInstallationId)
            throw new BadImplementationException('There is no origin instance found');
        if (!targetEHRInstallationId)
            throw new BadImplementationException('There is no target instance found');
        await ModuleFE_EHRInstallation._v1.copyOrderConfigsFromEHRInstallation({
            originEHRInstallationId: originEHRInstallationId,
            targetEHRInstallationId: targetEHRInstallationId,
        }).executeSync();
        ModuleFE_Dialog.close();
    };
    render() {
        const className = _className('quai-manager-ui__copy-orders-dialog', this.props.className);
        return _jsxs(LL_V_L, { className: className, id: this.props.id, children: [this.renderHeader(), this.renderEHRInstallationsDropDown(), this.renderButtons()] });
    }
    renderHeader = () => {
        return _jsx(LL_H_C, { className: 'quai-manager-ui__copy-orders-dialog__header', children: "Copy Orders From Another EHR Installation" });
    };
    renderEHRInstallationsDropDown = () => {
        return _jsx(DropDown_EHRInstallation.selectable, { selected: this.state.originEHRInstallationId, onSelected: this.onSelectEHRInstallation, queryFilter: (ehrInstallation) => ehrInstallation._id !== this.props.targetEHRInstallationId });
    };
    renderButtons = () => {
        return _jsx(Button, { variant: 'primary', className: 'quai-manager-ui__copy-orders-dialog__button', disabled: !this.state.canCopy, onClick: this.onClickCopy, children: "Copy Orders" }, 'copy-order');
    };
}
//# sourceMappingURL=Dialog_CopyOrders.js.map